export const getDeepCopyOfBidimensionalArray = (originalArray) => {
  return originalArray.map((row) => {
    return row.slice();
  });
};

export const checkOrder = (parsedValue) => {
  if (parsedValue === 'S' || parsedValue === 'N') {
    return false;
  }
  return true;
};
